import { IRoute } from "shared/interface/types";
import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";

const parentBreadCrumbs = [{ title: "menu_sidebar_management" }, { title: "menu_sidebar_manage_faq" }];

const Faq = Loadable({
  loader: () => import("container/faq"),
  loading() {
    return <Loader />;
  }
});

const FaqDetail = Loadable({
  loader: () => import("container/faq/detail"),
  loading() {
    return <Loader />;
  }
});

export const faqRoutes: IRoute[] = [
  {
    path: "/management/faq",
    element: <Faq />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  },
  {
    path: "/management/faq/details",
    element: <FaqDetail />,
    handle: {
      crumbs: [...parentBreadCrumbs, { title: "menu_sidebar_manage_faq" }]
    }
  }
];
